import { useCopy } from '@hooks/useCopy';
import { ReactElement } from 'react';
import { CopiedVariant } from './CopiedVariant/CopiedVariant';
import { LinkWrapper } from './LinkArticle.style';
import { LinkArticleProps } from './LinkArticle.types';
import { LinkVariant } from './LinkVariant/LinkVariant';

export const LinkArticle = ({
  articleLink,
  linkAsIcon,
  hoverColor,
}: LinkArticleProps): ReactElement => {
  const [copiedText, setCopiedText] = useCopy();

  const handleClick = () => {
    setCopiedText(articleLink);
  };

  return (
    <LinkWrapper onClick={handleClick} copied={copiedText !== null} linkAsIcon={linkAsIcon}>
      {copiedText === null || !linkAsIcon ? (
        <LinkVariant linkAsIcon={linkAsIcon} articleLink={articleLink} hoverColor={hoverColor} />
      ) : (
        ''
      )}
      {copiedText !== null ? <CopiedVariant linkAsIcon={linkAsIcon} /> : ''}
    </LinkWrapper>
  );
};
